var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 18.1953C14.7891 18.1953 18.3359 14.6484 18.3359 10.3594C18.3359 6.0625 14.7891 2.52344 10.4922 2.52344C6.20312 2.52344 2.66406 6.0625 2.66406 10.3594C2.66406 14.6484 6.21094 18.1953 10.5 18.1953ZM10.4531 7.35938C9.96094 7.35938 9.5625 6.96875 9.5625 6.48438C9.5625 5.98438 9.96094 5.59375 10.4531 5.59375C10.9375 5.59375 11.3281 5.98438 11.3281 6.48438C11.3281 6.96875 10.9375 7.35938 10.4531 7.35938ZM9.07031 14.7188C8.80469 14.7188 8.60938 14.5234 8.60938 14.2656C8.60938 14.0234 8.80469 13.8203 9.07031 13.8203H10.2109V9.71094H9.17188C8.91406 9.71094 8.71875 9.51562 8.71875 9.25781C8.71875 9.01562 8.91406 8.8125 9.17188 8.8125H10.7109C11.0234 8.8125 11.1953 9.03906 11.1953 9.36719V13.8203H12.3359C12.5938 13.8203 12.7969 14.0234 12.7969 14.2656C12.7969 14.5234 12.5938 14.7188 12.3359 14.7188H9.07031Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoFill);
export default __webpack_public_path__ + "static/media/info-fill.fbe44a30.svg";
export { ForwardRef as ReactComponent };